import { Component, Input, OnInit } from "@angular/core";
import { TourneeModel } from "src/app/models/tournee.model";
import { ContextService } from "src/app/services/context/context.service";
import { DateService } from "src/app/services/date/date.service";
import { HomeService } from "src/app/services/home-service/home.service";
import { MathService } from "src/app/services/math/math.service";
import { UtilsService } from "src/app/services/utils/utils.service";

@Component({
  selector: "sale-card",
  templateUrl: "./sale-card.component.html",
  styleUrls: ["./sale-card.component.scss"]
})
export class SaleCardComponent implements OnInit {
  @Input()
  tournee: TourneeModel;

  @Input()
  mode: string; // consumer, producer

  loading = false;

  statusToColor = {
    draft: "tertiary",
    open: "secondary",
    full: "primary",
    prepared: "primary",
    distributing: "primary",
    delivered: "primary",
    cancelled: "primary",
    closed: "primary"
  };

  constructor(public dateService: DateService, public mathService: MathService, private homeService: HomeService, public contextService: ContextService, public utils:UtilsService) {}

  ngOnInit() {}

  ngOnDestroy() {}
}
